export default __webpack_public_path__ + "static/media/right-icon.a8174ca1.svg";